import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

// Styled Checkbox
const StyledCheckbox = styled(Checkbox)(({ theme, customColor }) => ({
    color: customColor || theme.palette.primary.main,
    '&.Mui-checked': {
        color: customColor || theme.palette.primary.main,
    },
    '&:hover': {
        backgroundColor: `${customColor || theme.palette.primary.main}20`, // Light hover effect
    },
    '&.MuiCheckbox-root': {
        // padding: '0px 9px 0px 9px'

    }
}));

// Reusable Checkbox Component
export const MuiCheckbox = ({
    label,
    checked,
    onChange,
    disabled,
    customColor,
    labelPlacement,
}) => {
    return (
        <FormControlLabel
            control={
                <StyledCheckbox
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    customColor={customColor}
                />
            }
            label={label}
            labelPlacement={labelPlacement}
        />
    );
};

MuiCheckbox.propTypes = {
    label: PropTypes.string.isRequired, // Label for the checkbox
    checked: PropTypes.bool.isRequired, // Checked state
    onChange: PropTypes.func.isRequired, // Function to handle change
    disabled: PropTypes.bool, // Disabled state
    customColor: PropTypes.string, // Custom color for the checkbox
    labelPlacement: PropTypes.oneOf(['end', 'start', 'top', 'bottom']), // Label placement
};

MuiCheckbox.defaultProps = {
    disabled: false,
    customColor: '',
    labelPlacement: 'end',
};
